import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { QueryClient } from '@tanstack/react-query';
import { NotFoundPage } from '@/components/not-found/not-found-page';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <div className='w-full min-h-screen'>
      <Outlet />
    </div>
  ),
  notFoundComponent: () => <NotFoundPage />,
});
